import { render, staticRenderFns } from "./unapprovedShipments.vue?vue&type=template&id=1983d15a"
import script from "./unapprovedShipments.vue?vue&type=script&lang=js"
export * from "./unapprovedShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports